import { render, staticRenderFns } from "./FluxoMensagem.vue?vue&type=template&id=44105c9c&scoped=true&"
import script from "./FluxoMensagem.vue?vue&type=script&lang=js&"
export * from "./FluxoMensagem.vue?vue&type=script&lang=js&"
import style0 from "./FluxoMensagem.vue?vue&type=style&index=0&id=44105c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44105c9c",
  null
  
)

export default component.exports